/*
* Whitebox wrapper component for views
*/

import * as React from 'react';
import { Row } from 'react-bootstrap';

import { BootstrapColXl as Col } from './bootstrap/bootstrapcolxl';
import { IWhiteBoxSectionProps, WhiteBoxSection } from './whiteboxsection';

export interface IWhiteBoxPageSectionProps {
    children?: any;
    pageSectionColMd?: number;
    pageSectionColXl?: number;
    wrapperDivClassName?: string;
}

export class WhiteBoxPageSection extends React.Component<IWhiteBoxPageSectionProps & IWhiteBoxSectionProps, any> {
    public static defaultProps = {
        pageSectionColMd: 12,
        pageSectionColXl: 12,
        wrapperDivClassName: 'white-box',
    };

    public constructor(props: IWhiteBoxPageSectionProps & IWhiteBoxSectionProps) {
        super(props);
    }

    public render() {
        const {
            pageSectionColMd,
            pageSectionColXl,
            wrapperDivClassName,
            children,
            ...rest
        } = this.props;

        return (
            <Row>
                <Col xs={pageSectionColMd} xl={pageSectionColXl}>
                    <div className={wrapperDivClassName}>
                        <WhiteBoxSection {...rest}>
                            {children}
                        </WhiteBoxSection>
                    </div>
                </Col>
            </Row>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/whiteboxpagesection.tsx